<div class="recorder-bar" *ngIf="state !== 'idle'" [class.paused]="state === 'paused' || state === 'ready'">
  <div class="stats-side" (click)="minimize = !minimize">
    <div class="status-dot-container">
      <div class="recording-dot" [class.blink]="state === 'recording'" [class.ready]="state === 'ready'"></div>
    </div>
    
    <div class="main-stats" *ngIf="!error && state !== 'ready'">
      <div class="stat-group">
        <span class="val">{{ formatDuration(stats.durationMs) }}</span>
        <span class="label">{{ 'Duration' | translate }}</span>
      </div>
      <div class="stat-divider"></div>
      <div class="stat-group">
        <span class="val">{{ stats.distanceKm | number:'1.2-2' }}</span>
        <span class="label">km</span>
      </div>
      <div class="stat-group extra" *ngIf="!minimize">
        <span class="val">{{ stats.elevationGainMeters }}</span>
        <span class="label">m+</span>
      </div>
      <div class="stat-group extra" *ngIf="!minimize">
        <span class="val">{{ stats.currentSpeedKph | number:'1.1-1' }}</span>
        <span class="label">km/h</span>
      </div>
    </div>

    <div class="ready-msg" *ngIf="state === 'ready' && !error">
        <span>{{ 'Ready to start' | translate }}</span>
    </div>

    <div class="error-msg" *ngIf="error">
      <ion-icon name="warning-outline" color="warning"></ion-icon>
      <span>{{ error }}</span>
    </div>
  </div>

  <div class="controls-side">
    <ion-button fill="solid" [color]="state === 'recording' ? 'warning' : 'success'" (click)="togglePause()" class="control-btn play-pause">
      <ion-icon [name]="state === 'recording' ? 'pause' : 'play'" slot="icon-only"></ion-icon>
    </ion-button>
    <ion-button fill="solid" color="danger" (click)="stopRecording()" class="control-btn stop">
      <ion-icon name="stop" slot="icon-only"></ion-icon>
    </ion-button>
  </div>
</div>
